<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import { sanitizeRich } from "$lib/utils/sanitize";

  let {
    sectionLabel = "",
    headline = "",
    rows = [] as Array<{
      feature: string;
      cmsValue: string;
      jamstackValue: string;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    <div class="section-divider fade-up" use:observe>
      {#if sectionLabel}
        <span class="section-label">{sectionLabel}</span>
      {/if}
      <h2>{headline}</h2>
    </div>
    <div class="fade-up" use:observe style="overflow-x:auto">
      <table class="compare-table">
        <thead>
          <tr>
            <th scope="col"><span class="sr-only">Kriterium</span></th>
            <th scope="col">Klassisches CMS</th>
            <th scope="col">JamStack</th>
          </tr>
        </thead>
        <tbody>
          {#each rows as row}
            <tr>
              <td style="font-weight:600">{row.feature}</td>
              <td>{@html sanitizeRich(row.cmsValue)}</td>
              <td>{@html sanitizeRich(row.jamstackValue)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
</section>
